import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl, ValidatorFn } from '@angular/forms';
import { SubscribeService } from './subscribe.service';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-subscribe',
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.scss']
})
export class SubscribeComponent implements OnInit {
  subscribeForm!: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private subscribeService: SubscribeService,
    private notifier: NotifierService
  ) {}

  ngOnInit(): void {
    this.subscribeForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, this.emailValidator()]]
    });
  }

  emailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const email = control.value;
      const pattern = /^[^\d][\w.-]+@[a-zA-Z_-]+\.[a-zA-Z]{2,5}$/;
      const valid = pattern.test(email);
      return valid ? null : { invalidEmail: { value: email } };
    };
  }

  onSubmit(): void {
    const { email } = this.subscribeForm.value;
  
    this.subscribeService.subscribe(email, 'Newsletter').subscribe({
      next: () => {
        this.notifier.notify('success', 'Vous vous êtes inscrit avec succès.');
        this.subscribeForm.reset();
      },
      error: (error: any) => {
        let errorMessage = 'Une erreur est survenue. Veuillez réessayer plus tard.';
  
        if (error?.error?.data?.errors?.email) {
          const errorData = error.error.data.errors.email[0];
          errorMessage = errorData.includes('invalidDomain') ? 'Adresse email invalide.' : errorData;
        }

        const errorDetail = error?.error?.error?.message || '';
        const uniqueViolation = errorDetail.toLowerCase().includes('already taken') 
          || errorDetail.toLowerCase().includes('must be unique');
  
        if (uniqueViolation) {
          errorMessage = '⚠️ Vous êtes déjà inscrit.';
        }
  
        this.notifier.notify('error', errorMessage);
      }
    });
  }  
}
